import React,{ Component } from 'react'

class PrecioFila extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        valor : 0,
        icono:"fas fa-exchange-alt",
        update:false
    }
    this.cambia=this.cambia.bind(this)
    this.borra = this.borra.bind(this)
  }
  
  componentDidMount(){
  	this.setState({valor:this.props.datos.precio})
  }

  componentDidUpdate(prevProps, prevState){
  }
  
  cambia = (e) => {
    this.setState({[e.target.name]:e.target.value})
  }

  borra = (e) => {
    this.props.delPrecio(this.props.datos.id);
  }

  modifica = () => {
  	 this.setState({
  	 	icono:"fas fa-spinner",
  	 	update:true
  	 })
  }

  componentDidUpdate(prevProps, prevState){
  	if(this.state.update == true && prevState.update == false){
  	 	this.props.upPrecio(this.props.datos.id,this.state.valor)
  	}else if(this.state.update == true && prevState.update == true){
  		this.setState({
  	 		icono:"fas fa-exchange-alt",
  	 		update:false
  	 	})
  	}
  }


  render() {
	return(
		<tr>
            <td>{ this.props.datos.cantidad } > </td>
            <td>$
            <input
	          type="text"
	          name="valor"
	          value={ this.state.valor }
	          ref={this.precioInput}
	          onChange={this.cambia}
	        />
            </td>
            <td><button type="button" className="btn btn-info" onClick={this.modifica}><i className={this.state.icono}></i></button></td>
            <td><button type="button" className="btn btn-info" onClick={this.borra}><i className="fas fa-trash-alt" /></button></td>
         </tr>
		)
	}
}

export default PrecioFila;



// WEBPACK FOOTER //
// ./src/components/admin_precio_fila.js